<template>
  <v-container>
    <div
      class="mt-5"
      :class="{'mx-10': $vuetify.breakpoint.lgAndUp}"
      style="border:1px solid black"
    >
      <v-tabs
        ref="tabs"
        v-model="active"
        align-with-title
        slider-color="white"
        show-arrows
      >
        <v-tab
          v-for="item in filteredTabItems"
          :key="item.name"
          class="divider font-black"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="active">
        <v-tab-item
          v-if="$hasPermissionTo(['view leave types'])"
          class="pb-12"
        >
          <setup-leaves-leave-type-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view leave entitlements'])"
          class="pb-12"
        >
          <setup-leaves-leave-entitlement-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view leave entitlement settings'])"
          class="pb-12"
        >
          <setup-leaves-leave-entitlement-setting-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view leave lock settings'])"
          class="pb-12"
        >
          <setup-leaves-leave-lock-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view leave dashboard by departments'])"
          class="pb-12"
        >
          <setup-leaves-department-leave-dashboard-container-view />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupLeavesLeaveTypeContainerView: () => import('@/components/hris/setup/leaves/leave-type/ContainerView'),
      SetupLeavesLeaveLockContainerView: () => import('@/components/hris/setup/leaves/leave-lock/ContainerView'),
      SetupLeavesDepartmentLeaveDashboardContainerView: () => import('@/components/hris/setup/leaves/department-leave-dashboard/ContainerView'),
      SetupLeavesLeaveEntitlementSettingContainerView: () => import('@/components/hris/setup/leaves/leave-entitlement-setting/ContainerView'),
      SetupLeavesLeaveEntitlementContainerView: () => import('@/components/hris/setup/leaves/leave-entitlement/ContainerView'),
    },
    data () {
      return {
        tabItems: [ ],
        active: null,
      }
    },

    computed: {   
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
 
        if (this.$hasPermissionTo(['view leave types'])) {
          modifiedTab.push({ name: 'Leave Types' })
        }

        if (this.$hasPermissionTo(['view leave entitlements'])) {
          modifiedTab.push({ name: 'Leave Entitlements' })
        }

        if (this.$hasPermissionTo(['view leave entitlement settings'])) {
          modifiedTab.push({ name: 'Leave Entitlement Setting' })
        }

        if (this.$hasPermissionTo(['view leave lock settings'])) {
          modifiedTab.push({ name: 'Leave Lock' })
        }

        if (this.$hasPermissionTo(['view leave dashboard by departments'])) {
          modifiedTab.push({ name: 'Department Leave Dashboard' })
        }

        return modifiedTab
      },
    },
  }
</script>

<style scoped>
.divider { 
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
} 

.font-black{
  color:black !important;
}

.divider.font-black.v-tab.v-tab--active{
  border-bottom:0px;
}

.v-tab {
  text-transform: none !important;
  max-height: 33px;
}
</style>
